// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  background-color: #ffffff;
  border: none !important;
  width: 100%; }
  .form-control__headingWrapper {
    display: flex;
    justify-content: flex-start;
    width: 350px; }
  .form-control__title {
    font-family: "Outfit", sans-serif;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 1em;
    color: #2b074d; }
  .form-control__fieldWrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
    color: #ff0000;
    margin: 10px auto;
    font-size: 12px; }
  .form-control__field {
    width: 100%;
    padding: 10px;
    border: 1px solid #2b074d;
    border-radius: 8px;
    font-family: "Outfit", sans-serif;
    font-size: 16px;
    font-weight: 600;
    outline: none;
    background-color: transparent;
    font-size: 16px;
    color: #2b074d;
    transition: all 0.2s ease-out; }
  .form-control__date {
    width: 100%; }
  .form-control__select {
    margin-top: 15px; }
  .form-control__dropzone {
    width: 100%;
    border: 1px dashed purple;
    align-items: center;
    justify-content: center;
    display: flex;
    align-items: center;
    height: 80px;
    border-radius: 8px; }
    .form-control__dropzone p {
      color: #ff2481;
      margin: 0;
      text-align: center; }
    .form-control__dropzone:hover {
      cursor: pointer; }
  .form-control__label {
    color: #2b074d;
    font-family: "Outfit", sans-serif;
    font-size: 14px;
    font-weight: 400; }
  .form-control__formWrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column; }
  .form-control__form {
    max-width: 100%; }
  .form-control__btnSubmitWrapper {
    display: flex;
    max-width: 100%;
    justify-content: center;
    align-items: center;
    height: 80px;
    flex-direction: column; }
  .form-control__submitBtn {
    background-color: #ff2481 !important;
    border: #e02574 !important;
    border-radius: 6px;
    height: 48px;
    width: 100%;
    padding: 12px 12px; }
    .form-control__submitBtn:hover {
      background-color: #e02574 !important; }
  .form-control__error {
    color: #ff0000; }

/* Section Heading Styles */
.section-heading {
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 450px;
  gap: 10px; }
  .section-heading__count {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    padding: 10px;
    height: 50px;
    width: 50px;
    background-color: #2b074d;
    color: #ffffff;
    font-family: "Outfit", sans-serif;
    font-size: 24px;
    font-weight: 600; }
  .section-heading__title {
    font-size: 24px;
    font-weight: 700;
    color: #2b074d; }
  .section-heading__subtitle {
    font-family: "Outfit", sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #2b074d; }
  .section-heading____checkbox {
    display: flex;
    flex-direction: row; }

/* React Datepicker Styles */
.react-datepicker-wrapper {
  width: 100%;
  max-width: 500px; }

.react-datepicker__navigation--years {
  background: none;
  line-height: 1.7rem;
  text-align: center;
  cursor: pointer;
  padding: 0;
  border: 0.45rem solid transparent;
  z-index: 1;
  height: 10px;
  width: 10px;
  text-indent: -999em;
  overflow: hidden;
  position: relative;
  display: block;
  margin-left: auto;
  margin-right: auto; }

.react-datepicker__navigation--years.react-datepicker__navigation--years-upcoming {
  top: -4px;
  border-bottom-color: #ccc; }

.react-datepicker__navigation--years.react-datepicker__navigation--years-previous {
  top: 4px;
  border-top-color: #ccc; }
`, "",{"version":3,"sources":["webpack://./src/components/Form/style.scss","webpack://./src/styles/variables/_variables.scss","webpack://./src/styles/mixins/mixins.scss"],"names":[],"mappings":"AAGA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,yBCNuB;EDOvB,uBAAuB;EACvB,WAAW,EAAA;EAEX;IACE,aAAa;IACb,2BAA2B;IAC3B,YAAY,EAAA;EAGd;IElBE,iCAAiC;IACjC,eFkB4B;IEjB5B,gBFiBiC;IACjC,kBAAkB;IAClB,cCrB0B,EAAA;EDwB5B;IACE,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;IACR,cCrBsB;IDsBtB,iBAAiB;IACjB,eAAe,EAAA;EAGjB;IACE,WAAW;IACX,aAAa;IACb,yBCtC0B;IDuC1B,kBAAkB;IEvClB,iCAAiC;IACjC,eFuC4B;IEtC5B,gBFsCiC;IACjC,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,cC5C0B;ID6C1B,6BAA6B,EAAA;EAG/B;IACE,WAAW,EAAA;EAGb;IACE,gBAAgB,EAAA;EAGlB;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB,EAAA;IARnB;MAUG,cC9C8B;MD+C9B,SAAS;MACT,kBAAkB,EAAA;IAZrB;MAeG,eAAe,EAAA;EAInB;IACE,cC5E0B;ICA1B,iCAAiC;IACjC,eF4E4B;IE3E5B,gBF2EiC,EAAA;EAGnC;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB,EAAA;EAGxB;IACE,eAAe,EAAA;EAGjB;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB,EAAA;EAGxB;IACE,oCAAwD;IACxD,0BAA0C;IAC1C,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB,EAAA;IANnB;MAQG,oCAAoD,EAAA;EAIxD;IACE,cCzGsB,EAAA;;AD6G1B,2BAAA;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS,EAAA;EAET;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,yBCtI0B;IDuI1B,cCrIqB;ICFrB,iCAAiC;IACjC,eFuI4B;IEtI5B,gBFsIiC,EAAA;EAGnC;IACE,eAAe;IACf,gBAAgB;IAChB,cC9I0B,EAAA;EDiJ5B;IEjJE,iCAAiC;IACjC,eFiJ4B;IEhJ5B,gBFgJiC;IACjC,cCnJ0B,EAAA;EDqJ5B;IACE,aAAa;IACb,mBAAmB,EAAA;;AAIvB,4BAAA;AACA;EACE,WAAW;EACX,gBAAgB,EAAA;;AAElB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,iCAAiC;EACjC,UAAU;EACV,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,yBAAyB,EAAA;;AAG3B;EACE,QAAQ;EACR,sBAAsB,EAAA","sourcesContent":["@import \"../../styles/variables/variables\";\n@import \"../../styles/mixins/mixins.scss\";\n\n.form-control {\n  display: flex !important;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n  background-color: $tokenWhiteColor;\n  border: none !important;\n  width: 100%;\n\n  &__headingWrapper {\n    display: flex;\n    justify-content: flex-start;\n    width: 350px;\n  }\n\n  &__title {\n    @include tokenFontMixin(24px, 600);\n    margin-bottom: 1em;\n    color: $tokenBackgroundColor;\n  }\n\n  &__fieldWrapper {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 5px;\n    color: $tokenErrorStatus;\n    margin: 10px auto;\n    font-size: 12px;\n  }\n\n  &__field {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid $tokenBackgroundColor;\n    border-radius: 8px;\n    @include tokenFontMixin(16px, 600);\n    outline: none;\n    background-color: transparent;\n    font-size: 16px;\n    color: $tokenBackgroundColor;\n    transition: all 0.2s ease-out;\n  }\n\n  &__date {\n    width: 100%;\n  }\n\n  &__select {\n    margin-top: 15px;\n  }\n\n  &__dropzone {\n    width: 100%;\n    border: 1px dashed purple;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    align-items: center;\n    height: 80px;\n    border-radius: 8px;\n    & p {\n      color: $tokenButtonBackgroundColor;\n      margin: 0;\n      text-align: center;\n    }\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  &__label {\n    color: $tokenBackgroundColor;\n    @include tokenFontMixin(14px, 400);\n  }\n\n  &__formWrapper {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n\n  &__form {\n    max-width: 100%;\n  }\n\n  &__btnSubmitWrapper {\n    display: flex;\n    max-width: 100%;\n    justify-content: center;\n    align-items: center;\n    height: 80px;\n    flex-direction: column;\n  }\n\n  &__submitBtn {\n    background-color: $tokenButtonBackgroundColor !important;\n    border: $tokenButtonBorderColor !important;\n    border-radius: 6px;\n    height: 48px;\n    width: 100%;\n    padding: 12px 12px;\n    &:hover {\n      background-color: $tokenButtonBorderColor !important;\n    }\n  }\n\n  &__error {\n    color: $tokenErrorStatus;\n  }\n}\n\n/* Section Heading Styles */\n.section-heading {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  max-width: 450px;\n  gap: 10px;\n\n  &__count {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 8px;\n    padding: 10px;\n    height: 50px;\n    width: 50px;\n    background-color: $tokenBackgroundColor;\n    color: $tokenWhiteColor;\n    @include tokenFontMixin(24px, 600);\n  }\n\n  &__title {\n    font-size: 24px;\n    font-weight: 700;\n    color: $tokenBackgroundColor;\n  }\n\n  &__subtitle {\n    @include tokenFontMixin(16px, 400);\n    color: $tokenBackgroundColor;\n  }\n  &____checkbox {\n    display: flex;\n    flex-direction: row;\n  }\n}\n\n/* React Datepicker Styles */\n.react-datepicker-wrapper {\n  width: 100%;\n  max-width: 500px;\n}\n.react-datepicker__navigation--years {\n  background: none;\n  line-height: 1.7rem;\n  text-align: center;\n  cursor: pointer;\n  padding: 0;\n  border: 0.45rem solid transparent;\n  z-index: 1;\n  height: 10px;\n  width: 10px;\n  text-indent: -999em;\n  overflow: hidden;\n  position: relative;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.react-datepicker__navigation--years.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n  border-bottom-color: #ccc;\n}\n\n.react-datepicker__navigation--years.react-datepicker__navigation--years-previous {\n  top: 4px;\n  border-top-color: #ccc;\n}\n","// Main Colors\n$tokenBackgroundColor: #2b074d;\n$tokenContainerBackgroundColor: rgba($tokenBackgroundColor, 0.85);\n$tokenWhiteColor: #ffffff;\n$tokenBlackColor: #000000;\n$tokenPlaceholderColor: #757179;\n\n// Status Colors\n$tokenVerifyStatus: #60ffa8;\n$tokenPendingStatus: #ffdb81;\n$tokenErrorStatus: #ff0000;\n\n// SHADOW\n$tokenContainerShadow: 0 0 14px 0 #ff2481;\n\n// BORDER\n$tokenContainerRadius: 20px;\n$tokenContainerBorderColor: #340c5a;\n\n// BUTTON\n$tokenButtonBorderColor: #e02574;\n$tokenButtonBackgroundColor: #ff2481;\n$tokenButtonHoverColor: #e02574;\n\n// COIN BACKGROUND\n$tokenCoinBackground: #ededed;\n","@mixin tokenFontMixin($fontSize, $fontWeight) {\n    font-family: \"Outfit\", sans-serif;\n    font-size: $fontSize;\n    font-weight: $fontWeight;\n}\n\n@mixin tokenSection($height) {\n    margin-top: 1.25rem;\n    padding: 20px;\n    border-radius: $tokenContainerRadius;\n    background-color: $tokenContainerBackgroundColor;\n    box-shadow: $tokenContainerShadow;\n    min-height: $height;\n}\n\n@mixin tokenMainButton($color, $backgroundColor) {\n    background-color: $backgroundColor;\n    color: $color;\n    padding: 0.5em 1em;\n    border: 1.85px solid $tokenButtonBorderColor;\n    cursor: pointer;\n    border-radius: 6px;\n\n    &:hover {\n        background-color: $tokenButtonHoverColor;\n    }\n}\n\n@mixin tokenOutlineButton($color, $backgroundColor) {\n    background-color: $backgroundColor;\n    color: $color;\n    padding: 0.5em 1em;\n    border: 2px solid $tokenButtonBackgroundColor;\n    cursor: pointer;\n    border-radius: 6px;\n\n    &:hover {\n        background-color: $tokenButtonHoverColor;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
